import { useEffect } from 'react';
import { Table } from 'rsuite';
import { Layout } from '../../../components/Layout';
import { NetworkPricesFilters } from './Components/NetworkPricesFilters';
import { NetworkPricesHeader } from './Components/NetworkPricesHeader';
import { NetworkPricesResultBar } from './Components/NetworkPricesResultBar';
import { NetworkPricesTable } from './Components/NetworkPricesTable';
import { useApplyNetworkPrices } from './hooks/useApplyNetworkPrices';
import { useNetworkPricesQuery } from './hooks/useNetworkPricesQuery';
import { useNetworkPricesStore } from './NetworkPrices.store';
import styles from './NetworkPrices.module.scss';

const PAGE_SIZES = [25, 50, 100].map(value => ({ value, label: value }));

export const NetworkPrices = () => {
  const { data, isFetching } = useNetworkPricesQuery();
  const lines = data?.content ?? [];
  const total = data?.totalElements ?? 0;
  const { applySelected, canApply, isApplying } = useApplyNetworkPrices(lines);
  const selectedCount = useNetworkPricesStore(state => state.selectedLineKeys.length);
  const pagination = useNetworkPricesStore(state => state.pagination);
  const setPage = useNetworkPricesStore(state => state.setPage);
  const setPageSize = useNetworkPricesStore(state => state.setPageSize);
  const reset = useNetworkPricesStore(state => state.reset);

  useEffect(() => reset, [reset]);

  return (
    <Layout className={styles.page}>
      <NetworkPricesHeader />
      <NetworkPricesFilters />
      <Layout.Body className={styles.body}>
        <NetworkPricesResultBar total={total} selectedCount={selectedCount} canApply={canApply} isApplying={isApplying} onApply={applySelected} />
        <NetworkPricesTable lines={lines} isLoading={isFetching} />
        <Table.Pagination
          total={total}
          activePage={pagination.page + 1}
          displayLength={pagination.size}
          lengthMenu={PAGE_SIZES}
          onChangePage={page => setPage(page - 1)}
          onChangeLength={setPageSize}
        />
      </Layout.Body>
    </Layout>
  );
};
